import { swRequest } from "@sourcewhale/core";

export const getAllIntegrations = (params) =>
  swRequest({ path: "/api/integrations/get_all", method: "GET", params });

export const saveIntegrationSettings = (provider, settings) => {
  const requestBody = {
    provider,
    choices: settings.choices,
    customMap: settings.customMap,
    lockedChoices: settings.lockedChoices,
    dataRefresh: settings.dataRefresh,
  };

  return swRequest({
    path: "/api/integrations/save",
    method: "POST",
    body: requestBody,
  });
};

export const activationUrl = (params) =>
  swRequest({
    path: "/api/integrations/activation_url",
    method: "GET",
    params,
  });

export const saveApiKey = (body) =>
  swRequest({
    path: "/api/integrations/save_api_key",
    method: "POST",
    body,
  });

export const saveIntegrationChoices = (provider, choices) =>
  swRequest({
    path: "/api/integrations/save",
    method: "POST",
    body: { provider, choices },
  });

export const deactivateCrm = async (provider) =>
  swRequest({
    path: "/api/integrations/deactivate",
    method: "POST",
    body: { provider },
  });
